import {InjectionToken} from '@angular/core'
import {IEnvironment} from './types'

export const LOCAL_STORAGE = new InjectionToken<Storage>('storage')
export const ENVIRONMENT = new InjectionToken<IEnvironment>('environment')